'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _FontDescriptor = require('./FontDescriptor');

var _FontDescriptor2 = _interopRequireDefault(_FontDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RunStyle = function RunStyle() {
  var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, RunStyle);

  this.color = attributes.color || 'black';
  this.backgroundColor = attributes.backgroundColor || null;
  this.fontDescriptor = _FontDescriptor2.default.fromAttributes(attributes);
  this.font = attributes.font || null;
  this.fontSize = attributes.fontSize || 12;
  this.lineHeight = attributes.lineHeight || null;
  this.underline = attributes.underline || false;
  this.underlineColor = attributes.underlineColor || this.color;
  this.underlineStyle = attributes.underlineStyle || 'solid';
  this.strike = attributes.strike || false;
  this.strikeColor = attributes.strikeColor || this.color;
  this.strikeStyle = attributes.strikeStyle || 'solid';
  this.link = attributes.link || null;
  this.fill = attributes.fill !== false;
  this.stroke = attributes.stroke || false;
  this.features = attributes.features || [];
  this.wordSpacing = attributes.wordSpacing || 0;
  this.yOffset = attributes.yOffset || 0;
  this.characterSpacing = attributes.characterSpacing || 0;
  this.attachment = attributes.attachment || null;
  this.script = attributes.script || null;
  this.bidiLevel = attributes.bidiLevel || null;
};

exports.default = RunStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/models/RunStyle.js
// module id = 493
// module chunks = 0